module.exports = __webpack_public_path__ + "static/media/AliaCai.ada4b97a.jpg";